import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import CloseIcon from '@material-ui/icons/Close';
import { makeSelectClientDetails } from 'containers/Main/selectors';

const useStyles = makeStyles(theme => ({
  root: {
    boxSizing: 'border-box',
    minHeight: props => props.filterPillHeight,
    border: '1px solid #CFD2D3',
    fontFamily: 'MadaRegular',
    color: theme.palette.text.primary,
    borderRadius: 18,
    fontSize: 14,
    lineHeight: '16px',
    textAlign: 'center',
    padding: 9,
    minWidth: 76,
    marginRight: 7,
    marginBottom: 5,
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#F9F9F9',
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderColor: theme.palette.primary.main,
    '&:hover': {
      opacity: 0.9,
      backgroundColor: theme.palette.primary.main,
    },
  },
  removeIcon: {
    fontSize: 16,
    color: '#8C99A1',
    marginRight: 4,
  },
  removeMarginBottom: {
    marginBottom: 0,
  },
}));

function FilterPill({
  filter,
  onClick,
  keepLabel,
  withRemoveIcon,
  removeMarginBottom,
  filterPillHeight,
}) {
  const classes = useStyles({ filterPillHeight });
  const clientDetails = useSelector(makeSelectClientDetails());

  const { label, type, isSelected, value } = filter;

  if (!label) return null;

  let finalLabel = label;
  if (!keepLabel && label.toLowerCase() === 'people') finalLabel = 'Leaders';
  if (label.toLowerCase() === 'client exclusive')
    finalLabel = _get(clientDetails, 'formalShortName', 'Client Exclusive');

  const finalValue = value || label;

  return (
    <ButtonBase
      className={ClassNames(classes.root, {
        [classes.active]: isSelected && !withRemoveIcon,
        [classes.removeMarginBottom]: removeMarginBottom,
      })}
      onClick={() => onClick(type, finalValue)}
      disableRipple
    >
      {isSelected && withRemoveIcon && (
        <CloseIcon className={classes.removeIcon} />
      )}
      {finalLabel}
    </ButtonBase>
  );
}

FilterPill.defaultProps = {
  filterPillHeight: '100%',
};

FilterPill.propTypes = {
  filter: PropTypes.object,
  onClick: PropTypes.func,
  keepLabel: PropTypes.bool,
  withRemoveIcon: PropTypes.bool,
  removeMarginBottom: PropTypes.bool,
  filterPillHeight: PropTypes.string,
};
export default FilterPill;
